import {useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {EVENT_ANALYTICS_TYPE_UPDATED, trackUpdate} from "../../../../utils/matomoEvents";
import Api, {DEFAULT_ERROR_MESSAGE} from "../../../../api/Api";

export const useScatterTable = (coordinates: number[]) => {
  const [scatterTableData, setScatterTableData] = useState<any[]>([])
  const [scatterTableLinks, setScatterTableLinks] = useState<string[]>([])
  const [scatterTableError, setScatterTableError] = useState('')

  const scatterTableMutation = useMutation({
    mutationFn: async (payload: any) => {
      const result = await Api.chart.getScatterTable(payload)
      return { result, payload }

    },
    onSuccess: ({ result, payload }) => {
      if (result?.Data) {
        setScatterTableData(result.Data)
        setScatterTableLinks(result.DownloadLinks || [])
        setScatterTableError('')
        trackUpdate(EVENT_ANALYTICS_TYPE_UPDATED, coordinates, payload.DatasetId, 'scatter table')
      } else {        
        const error = result?.Error?.ErrorMessage || DEFAULT_ERROR_MESSAGE
        setScatterTableError(error)
        setScatterTableData([])
        setScatterTableLinks([])
      }
    },
    onError: () => {
      setScatterTableError(DEFAULT_ERROR_MESSAGE)
      setScatterTableData([])
      setScatterTableLinks([])
    }
  })

  const resetScatterTable = () => {
    setScatterTableData([])
    setScatterTableLinks([])
    setScatterTableError('')
  }

  return {
    scatterTableData,
    scatterTableLinks,
    scatterTableError,
    resetScatterTable,
    updateScatterTable: scatterTableMutation.mutate,
    isUpdatingScatterTable: scatterTableMutation.isPending
  }
}
